import React, {forwardRef} from 'react'
import {connect} from "dva";
import {useUpdateEffect} from "ahooks";

import {Spin, Typography} from "antd";

import constants from '@/constants'
import {modelUtils} from "@/utils";
import {ExportExcel} from "@/components";

const {Paragraph} = Typography


const configs = {
  0: {
    title: '能力积分导入',
    href: constants.files.excel_learningScore1,
    dataFormat: (data) => {
      const {
        '月度': date,
        '账号': userName,
        '销售代码': preSalesNumber,
        '组织编码': orgCode,
        '岗位编码': positionCode,
        '积分渠道': source,
        '积分': score,
        '备注': remark,
      } = data

      return {
        date,
        userName,
        orgCode,
        preSalesNumber,
        positionCode,
        dataType: 0,
        dataValue: score,
        source,
        remark,
      }
    }
  },
  1: {
    title: '能力状态导入',
    href: constants.files.excel_learningScore2,
    dataFormat: (data) => {
      const {
        '月度': date,
        '账号': userName,
        '售后代码': afterSalesNumber,
        '状态': state,
        '备注': remark,
      } = data

      return {
        date,
        userName,
        afterSalesNumber,
        dataType: 1,
        dataValue: state,
        remark,
      }
    }
  },
}
const Index = (
  {
    refInstance: ref,
    dispatch,
    learningScoreRecordLoading = false,
    importRes,

    type,
    changeModal,
  }
) => {
  useUpdateEffect(() => {
    const {success, msg, data} = importRes || {}

    if (!success) {
      wizNotice.error(msg);
      return;
    }
    wizNotice.success({
      key: 'default',
      message: '成功',
      description: <div dangerouslySetInnerHTML={{__html: typeof data === 'string' ? data?.replaceAll?.('\r\n', '<br/>') || msg : msg}}/>,
      duration: 10,
    })
    changeModal && changeModal(false, true)
  }, [importRes])


  const infoProps = {
    title: '导入说明',
    text: [
      <Paragraph>1、从模版链接中下载模版文件</Paragraph>,
      <Paragraph>2、按照要求格式填写信息</Paragraph>,
      <Paragraph>3、当完成Excel文件的填写后，点击“上传文件”按钮上传此文件</Paragraph>,
    ]
  }

  const config = configs[type]

  const operateProps = {
    title: config?.title || '未知',
    template: {
      label: '模版下载',
      fileName: '模版.xlsx',
      href: config?.href,
    }
  }

  const submit = (file, fileData, other) => {
    console.log('submit:', file, fileData, other)
    console.table(fileData)
    const data = fileData
        ?.map(item => config?.dataFormat ? config?.dataFormat(item) : item)
      || []

    dispatch({
      type: `learningScoreRecord/import`,
      payload: {
        key: 'learningScoreRecord@import',
        apiParams: {
          list: data,
        }
      }
    })
  }


  return (
    <div>
      <Spin tip={'文件上传中'} spinning={learningScoreRecordLoading}>
        <ExportExcel
          infoProps={infoProps}
          operateProps={operateProps}
          // other={other}
          submit={submit}
        />
      </Spin>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => {
  const {learningScoreRecord} = state

  const importRes = modelUtils.getModelEntity(learningScoreRecord, 'learningScoreRecord@import');
  const load = modelUtils.getLoadingState(state, ['learningScoreRecord']);

  return {
    importRes,
    ...load,
  }
};

const Tc = connect(mapStateToProps, null, null, {forwardRef: true})(Index)
export default forwardRef((props, ref) => <Tc {...props} refInstance={ref}/>)

